import React from 'react';
import { makeStyles, ThemeProvider } from '@material-ui/core';
import { toaTheme } from './assets/toa-theme';
import { Router } from 'router';
import { SnackbarProvider } from 'notistack';
import { withAuth } from 'components/WithAuth';
import { Toast } from 'components/Toast';

const RootApp: React.FC = (props) => {
	// custom colors for toasts
	const useStyles = makeStyles((theme) => ({
		success: { backgroundColor: '#00B268 !important' },
		error: { backgroundColor: '#ED1400 !important' },
		warning: { backgroundColor: '#ed8b00 !important' },
		info: { backgroundColor: '#8B00ED !important' },
	}));

	const classes = useStyles();
	return (
		<ThemeProvider theme={toaTheme}>
			<SnackbarProvider
				maxSnack={4}
				classes={{
					variantSuccess: classes.success,
					variantError: classes.error,
					variantWarning: classes.warning,
					variantInfo: classes.info,
				}}
			>
				<div className="App">
					<Toast></Toast>
					<Router />
				</div>
			</SnackbarProvider>
		</ThemeProvider>
	);
};

export default withAuth(RootApp);
